import React from "react";
import { Box, Typography } from "@mui/material";
import {
    PtiAssetType,
    useGetPtiHistoryByTrailerQuery,
    useGetPtiHistoryByVehicleQuery,
} from "../../../api/ptiApi";
import PtiHistoryList from "./PtiHistoryList";

interface PtiHistoryTabProps {
    assetType: PtiAssetType;
    assetId: number;
}

const TAB_COPY: Record<PtiAssetType, string> = {
    Vehicle:
        "View pre-trip inspections submitted for this vehicle, including photos, notes, and tire measurements.",
    Trailer:
        "View pre-trip inspections submitted for this trailer, including photos, notes, and tire measurements.",
};

const PtiHistoryTab: React.FC<PtiHistoryTabProps> = ({ assetType, assetId }) => {
    const vehicleQuery = useGetPtiHistoryByVehicleQuery(
        { vehicleId: assetId, pageNumber: 1, pageSize: 50 },
        { skip: assetType !== "Vehicle" }
    );
    const trailerQuery = useGetPtiHistoryByTrailerQuery(
        { trailerId: assetId, pageNumber: 1, pageSize: 50 },
        { skip: assetType !== "Trailer" }
    );

    const { data, isLoading, isFetching, error } =
        assetType === "Vehicle" ? vehicleQuery : trailerQuery;

    return (
        <Box>
            <Box sx={{ mb: 2 }}>
                <Typography variant="h6" gutterBottom>
                    PTI History
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {TAB_COPY[assetType]}
                </Typography>
            </Box>
            <PtiHistoryList
                assetType={assetType}
                inspections={data?.items}
                isLoading={isLoading || isFetching}
                error={error}
            />
        </Box>
    );
};

export default PtiHistoryTab;
